import React from 'react';
import c from 'classnames';
import s from './HorizontalLayout.scss';

interface Props {
  children: React.ReactNode;
  /**
   * Space between each item in pixels.
   */
  // Testing this API. Starting with some common values. This won't work if we need to differentiate gap between mobile and desktop.
  // In that case, maybe take a tuple? First value mobile, second value desktop? Allowing `undefined` without a default means consumers
  // can still control the gap via `className`. Is that a benefit?
  gap?: 0 | 8 | 16 | 24;
  className?: string;
}

const HorizontalLayout: React.FC<Props> = ({ children, gap, className }) => (
  <div className={c(s['root'], className)} style={{ gap: `${gap}px` }}>
    {children}
  </div>
);

HorizontalLayout.displayName = 'HorizontalLayout';

export default HorizontalLayout;
